var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"menuTips",class:{ alt: _vm.black && !_vm.open },on:{"click":_vm.test}}),(_vm.open)?_c('menuu'):_vm._e(),_c('router-view'),(_vm.$route.path !== '/about')?_c('foo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }